export default {"src":"/sg/_next/static/media/MINI.0badd089.svg","height":150,"width":63,"blurWidth":0,"blurHeight":0};